import { CurrencyRubIcon } from './CurrencyRubIcon';

/**
 * author: Google
 * id 57057EA1-1BA7-49F3-A8C7-51AF633DED68
 * name currency-rub
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/currency-rub.svg
 * tags
 * - Currency 
 * - Banking 
 */
export const RubleIcon = CurrencyRubIcon;
export default RubleIcon